// extracted by mini-css-extract-plugin
export default {"productGrid":"Gca-z","centerLink":"Hca-z","productSection":"Ica-z","item":"Jca-z","ctaButton":"Kca-z"};